import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../../../selectors';
import PollVisualization from './PollVisualization.component';

const PollVisualizationContainer = props => <PollVisualization {...props} />;

const mapStateToProps = (state, ownProps) => ({
	// isLoading true = data not fetched from endpoint; false = data fetched
	isLoading: apiSelectors.polls.isLoadingSelector(state),
	// status: disabled, bootstrapping, failed, initialized
	status: apiSelectors.polls.statusSelector(state),
	// enabled: is this component enabled or not (only to be known when `!isLoading && status == 'initialized'`)
	enabled: apiSelectors.polls.enabledSelector(state),
	isVisible: (appSelectors.ui.interactionsSelector(state).polls || {}).visible || false,
	polls: apiSelectors.polls.pollsSelector(state),
	results: apiSelectors.polls.resultsSelector(state),
	pollStatus: apiSelectors.polls.pollStatusSelector(state),
	user: apiSelectors.auth.userSelector(state),
	config: apiSelectors.config.configSelector(state),
	locale: appSelectors.locale.localeSelector(state),
	theming: appSelectors.ui.themingSelector(state),
});

const mapDispatchToProps = () => ({});

PollVisualizationContainer.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	what: PropTypes.string.isRequired,
};
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PollVisualizationContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/pollvisualization/PollVisualization.container.js